import { ref } from 'vue'
import { updateOrganisationInvoiceChannel } from '@/api/invoicing'
import { validationErrors } from '@/lib/httpErrors'
import type { OrganisationInvoiceChannel, OrganisationInvoiceChannelPayload } from '@/types/invoicing'

export function useOrganisationInvoiceChannel() {
  const saving = ref(false)
  const actionError = ref<string | null>(null)
  const fieldErrors = ref<Record<string, string[]>>({})

  // Returns the saved channel, or null when the request failed (see fieldErrors / actionError).
  async function update(
    organisationId: number,
    payload: OrganisationInvoiceChannelPayload,
  ): Promise<OrganisationInvoiceChannel | null> {
    saving.value = true
    actionError.value = null
    fieldErrors.value = {}
    try {
      return await updateOrganisationInvoiceChannel(organisationId, payload)
    } catch (e: unknown) {
      const errors = validationErrors(e)
      if (errors !== null) {
        fieldErrors.value = errors
      } else {
        actionError.value = 'admin.common.error_generic'
      }
      return null
    } finally {
      saving.value = false
    }
  }

  return { saving, actionError, fieldErrors, update }
}
